import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=b016a9a4"
import script from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@2.7.16_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vu_qgmhcv2zwyplqohcijlq2qcl3q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports